import { IntlShape } from 'react-intl';

class DateTime {
  static formatDate(intl: IntlShape, date: Date | undefined) {
    if (!date) {
      return '';
    }

    return intl.formatDate(date, {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
    });
  }
}

export default DateTime;
